// src/shared/telemetry/StreamProgress.tsx
// ────────────────────────────────────────────────────────────────────────────
// Slim streaming progress bar — visible during cascade data loading.
// Shared across all telemetry dashboards.
// ────────────────────────────────────────────────────────────────────────────

import React from 'react'

export interface StreamProgressProps {
  progress: number
}

export default function StreamProgress({ progress }: StreamProgressProps) {
  const pct = Math.round(progress * 100)
  return (
    <div className="flex items-center gap-2 ml-auto">
      <div className="w-20 h-1 rounded-full bg-white/[0.06] overflow-hidden">
        <div
          className="h-full rounded-full bg-emerald-500/70 transition-[width] duration-300 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="text-[10px] font-mono text-neutral-500 tabular-nums">{pct}%</span>
    </div>
  )
}
